import React from 'react';
import Helmet from 'react-helmet';
import { getSubdomain, UTM_DEFAULT_AFFILIATE } from '../../../utils/const';
import { sentryError } from '../../../utils/sentryHelpers';

const {
  Heading,
  ThreePieceQuotingWidgetAPI,
} = pm_components;

const Widgets = () => {
  return <>
    <Helmet>
      <title>PolicyMe | Life Insurance Made Easy</title>
      <meta
        name="description"
        content="PolicyMe is Canada’s #1 place for life insurance advice.  Take our free online life insurance check-up to get a personalized recommendation in less than 5 minutes."
      />
    </Helmet>
    <main>
      <div className="page-body">
        <ThreePieceQuotingWidgetAPI
          isAffiliate
          title="How much would my life insurance policy cost?"
          defaultUtms={UTM_DEFAULT_AFFILIATE}
          onError={sentryError}
          subdomain={getSubdomain()}
          PM_ENABLE_BROKER_SALES={process.env.GATSBY_PM_ENABLE_BROKER_SALES}
          PM_ENABLE_PM_PRODUCT={process.env.GATSBY_PM_ENABLE_PM_PRODUCT}
        />
      </div>
    </main>
    <style jsx>
      {`
        .page-body {
          text-align: center;
        }
      `}
    </style>
  </>;
};

export default Widgets;
